module.exports = __webpack_public_path__ + "img/254.666be607.jpg";